import type { CSSProperties, ReactNode } from 'react'

const SIZE = { h2: 20, h3: 15 } as const

/** A real h2/h3: getByRole('heading') depends on it, and so does the document outline. */
export function Heading({
  type = 'h2',
  children,
  style,
}: {
  readonly type?: 'h2' | 'h3'
  readonly children: ReactNode
  readonly style?: CSSProperties
}) {
  const Tag = type
  return (
    <Tag
      style={{
        margin: 0,
        fontFamily: 'var(--font-display)',
        fontSize: SIZE[type],
        fontWeight: 600,
        letterSpacing: '-0.01em',
        color: 'var(--fg)',
        ...style,
      }}
    >
      {children}
    </Tag>
  )
}
